import { CircularProgress } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React from 'react';
import VyTooltip from '../../../../../common/VyTooltip';

export interface ScoreIndicatorProps {
  score: number;
  disabled: boolean;
}
export const ScoreIndicator = (props: ScoreIndicatorProps) => {
  const { score, disabled } = props;

  const { t } = useTranslation();

  if (disabled || score === 0) return null;

  return (
    <div className="w-full justify-center items-center h-10 relative">
      <div className="w-10 h-10 absolute flex justify-center items-center">
        <CircularProgress variant="determinate" value={score} />
      </div>
      <div className="w-10 h-10 absolute flex justify-center items-center">
        <VyTooltip title={t('meeting:speeddating.history.point-description')}>
          <>{score.toFixed(0)}%</>
        </VyTooltip>
      </div>
    </div>
  );
};
